import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'deletingLocations': false,
  'releasingLocations': false,
  'settingAvailable': false,
  'count': 0,
  'list': [],
  'summary': null,
  'selectedLocations': [],
  'limit': 20,
  'offset': 0,
  'downloading': false,
  'updateTable': false,
};

const updateSelectedLocations = (selectedLocations, location) => {
  if (selectedLocations.indexOf(location) > -1) {
    return selectedLocations.filter((item) => item !== location);
  }

  return [...selectedLocations, location];
};

export const warehouseAllocations = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESET_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.GETTING_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      'loading': true,
      'selectedLocations': [],
    }),
    [ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      'loading': false,
      'count': action.response.count,
      'list': action.response.data,
      'summary': action.response.summary,
    }),
    [ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'count': 0,
      'list': [],
      'summary': null,
    }),
    [ActionTypes.CHANGE_WAREHOUSE_ALLOCATIONS_PAGE]: (state, action) => ({
      ...state,
      'offset': action.payload,
    }),
    [ActionTypes.CHANGE_WAREHOUSE_ALLOCATIONS_PAGE_SIZE]: (state, action) => ({
      ...state,
      'limit': action.payload,
    }),
    [ActionTypes.CLEAR_SELECTED_LOCATIONS]: (state, action) => ({
      ...state,
      'selectedLocations': [],
    }),
    [ActionTypes.UPDATE_SELECTED_LOCATIONS]: (state, action) => ({
      ...state,
      'selectedLocations': updateSelectedLocations(state.selectedLocations, action.payload),
    }),
    [ActionTypes.DELETING_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'deletingLocations': true,
    }),
    [ActionTypes.DELETED_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'deletingLocations': false,
      'selectedLocations': [],
      'list': [],
      'summary': null,
      'count': 0,
      'offset': 0,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.DELETED_WAREHOUSE_LOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'deletingLocations': false,
    }),
    [ActionTypes.RELEASING_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'releasingLocations': true,
    }),
    [ActionTypes.RELEASED_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'releasingLocations': false,
      'selectedLocations': [],
      'list': [],
      'summary': null,
      'count': 0,
      'offset': 0,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.RELEASED_WAREHOUSE_LOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'releasingLocations': false,
    }),


    [ActionTypes.SETTING_AVAILABLE_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'settingAvailable': true,
    }),
    [ActionTypes.SET_AVAILABLE_WAREHOUSE_LOCATIONS]: (state, action) => ({
      ...state,
      'settingAvailable': false,
      'selectedLocations': [],
      'list': [],
      'summary': null,
      'count': 0,
      'offset': 0,
      'updateTable': !state.updateTable,
    }),
    [ActionTypes.SET_AVAILABLE_WAREHOUSE_LOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'settingAvailable': false,
    }),


    [ActionTypes.PRINT_WAREHOUSE_LOCATIONS_LABELS]: (state, actions) => ({
      ...state,
      'selectedLocations': [],
    }),
    [ActionTypes.DOWNLOADING_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_WAREHOUSE_ALLOCATIONS]: (state, action) => {
      downloadFile(action.response.data);

      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_WAREHOUSE_ALLOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
